// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TokenBalanceChange } from './TokenBalanceChange';
import {
    TokenBalanceChangeFromJSON,
    TokenBalanceChangeFromJSONTyped,
    TokenBalanceChangeToJSON,
} from './TokenBalanceChange';

/**
 * 
 * @export
 * @interface AccountData
 */
export interface AccountData {
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    account: string;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    nativeBalanceChange: number;
    /**
     * 
     * @type {Array<TokenBalanceChange>}
     * @memberof AccountData
     */
    tokenBalanceChanges: Array<TokenBalanceChange> | null;
}

/**
 * Check if a given object implements the AccountData interface.
 */
export function instanceOfAccountData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "account" in value;
    isInstance = isInstance && "nativeBalanceChange" in value;
    isInstance = isInstance && "tokenBalanceChanges" in value;

    return isInstance;
}

export function AccountDataFromJSON(json: any): AccountData {
    return AccountDataFromJSONTyped(json, false);
}

export function AccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': json['account'],
        'nativeBalanceChange': json['nativeBalanceChange'],
        'tokenBalanceChanges': (json['tokenBalanceChanges'] === null ? null : (json['tokenBalanceChanges'] as Array<any>).map(TokenBalanceChangeFromJSON)),
    };
}

export function AccountDataToJSON(value?: AccountData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': value.account,
        'nativeBalanceChange': value.nativeBalanceChange,
        'tokenBalanceChanges': (value.tokenBalanceChanges === null ? null : (value.tokenBalanceChanges as Array<any>).map(TokenBalanceChangeToJSON)),
    };
}

